import { render, staticRenderFns } from "./Offers.vue?vue&type=template&id=ab8b1106&scoped=true&"
import script from "./Offers.vue?vue&type=script&lang=ts&"
export * from "./Offers.vue?vue&type=script&lang=ts&"
import style0 from "./Offers.vue?vue&type=style&index=0&id=ab8b1106&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab8b1106",
  null
  
)

export default component.exports